<template>
  <div class="metting-upload-action" :class="{'onlyValue-rest': onlyValue}">
    <!-- <div class="my-upload-list" :style="{'max-height':isMax && !handelMore ? '146px' : maxHeight}"> -->
    <div class="my-upload-list" :style="{'max-height':isMax && !handelMore ? '140px' : maxHeight}">
      <div class="upload-list-box" v-for="(file) in [...currentValue,...isUploadArr].reverse()" :key="file.id || file.uid">
        <!-- <el-tooltip effect="dark" :disabled="file.loading" :content="isCanPreview(file.attachment_type) ? '点击预览' : '点击下载'" placement="top" @click.native="downLoadData(file)"> -->
        <div class="upload-list---item">
          <div class="upload-list---text">
            <img :class="{'upload-list---text-img': onlyValue}" :src="getIconType(file)" alt="">
            <div class="upload-list---text-in">
              <p v-if="file.attachment_name">
                <span>
                  {{file.attachment_name.substr(0,getHeadText(file.attachment_name))}}
                </span>
                <span>{{file.attachment_name.substr(getHeadText(file.attachment_name))}}</span>
              </p>
              <div class="el-progress-custom" v-if="file.percentage < 100 && onlyValue">
                <el-progress :percentage="file.percentage" :show-text="false"></el-progress>
              </div>
            </div>
          </div>
          <div class="el-progress-custom upoloadBox" v-if="file.percentage < 100 && !onlyValue">
            <el-progress :percentage="file.percentage" :show-text="false"></el-progress>
          </div>
          <div class="el-progress-custom" v-if="file.onDownLoading < 100 && file.onDownLoading > 0 && !onlyValue">
            <el-progress :percentage="file.onDownLoading" :show-text="true"></el-progress>
          </div>
        </div>
        <!-- </el-tooltip> -->
        <div class="my-upload-del not-none" v-if="file.percentage < 100">
          <span>{{getfilesize(file.attachment_size || file.size)}}</span>
          <i class="icon iconfont iconicon_close1 tableIconHover" @click="cancelUpload(file)" style="margin-left: 16px;"></i>
        </div>
        <div class="my-upload-del" v-else>
          <span class="my-upload-del-szie">{{getfilesize(file.attachment_size || file.size)}}</span>
          <div class="tool-icon">
            <i v-if="isCanPreview(file.attachment_type)" class="icon iconfont iconicon_look_over_nor tableIconHover" style="margin-right: 8px;" @click="openViewReview(file)" ></i>
            <i class="icon iconfont iconicon_download tableIconHover" style="margin-right: 8px;" @click="downLoadData(file)"></i>
            <el-popover placement="top" popper-class="del-tip-popover" width="256" trigger="click" v-model="file.visible" :append-to-body="true">
              <div class="del-tip-content">
                <img src="image/icon/alert.png" alt="">
                <span>确定删除该附件吗？</span>
              </div>
              <div class="btns">
                <span class="cancel text-btn-active" @click="file.visible = false">取消</span>
                <!-- <wf-button plain style="margin-right:24px;" @click="file.visible = false">取消</wf-button> -->
                <wf-button type="danger" @click="removeFile(file)">确定</wf-button>
              </div>
              <div slot="reference">
                <i class="icon iconfont iconicon_close1 tableIconHover" v-if="!readonly"></i>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
    </div>
    <div class="file-bottom">
      <UploadOss ref="upload" upload_type="ordinary" type="attachment" @onUploadProgress="onUploadProgress">
        <div class="upload-box" v-if="onlyValue && !readonly">
          <i class="icon iconfont iconicon_enlarge"></i>
          添加附件
        </div>
        <div class="upload-box" v-else-if="!readonly">
          添加
        </div>
        <el-input ref="hashInput" class="add-box-input" type="textarea" v-model="taskName" size="mini"></el-input>
      </UploadOss>
      <div v-if="isMax && !onlyValue" class="more-box" @click="handelMore = !handelMore">
        <div class="more-msg" v-if="!handelMore">查看更多<i class="icon iconfont iconicon_arrow_task"></i></div>
        <div class="more-msg" v-else>收起<i class="icon iconfont iconicon_arrow_task2"></i></div>
      </div>
    </div>
    <!-- <div @click="selfupload">上传</div> -->
  </div>
</template>
<script>
import projectConfig from '@config/projectConfig'
import { Cookie } from '@/utils/utils'
import downApi from '@/services/api/downFile'
import UploadOss from '@/components/uploadOss'
import bus from '@/bus'
export default {
  props: ['value', 'readonly', 'type', 'config', 'isOpend', 'item', 'onlyValue'],
  components: {
    UploadOss
  },
  data() {
    return {
      visible: false,
      isMax: false,
      handelMore: false,
      taskName: '',
      fileIcon: [
        {
          icon: '/image/icon/icon_mp4_annex.png',
          list: 'mp4,avi,flv,wav,mov,mpeg,dat,mpg'
        },
        {
          icon: 'image/icon/icon_doc_annex.png',
          list: 'doc,docx,text'
        }, {
          icon: 'image/icon/icon_gif_annex.png',
          list: 'gif'
        }, {
          icon: 'image/icon/icon_jpg_annex.png',
          list: 'jpg,jpeg,png,bmp,svg'
        }, {
          icon: 'image/icon/icon_xls_annex.png',
          list: 'xls,xlsx'
        }, {
          icon: 'image/icon/icon_ppt_annex.png',
          list: 'ppt,pptx'
        }, {
          icon: 'image/icon/icon_pdf_annex.png',
          list: 'pdf'
        }
      ],
      projectConfig: projectConfig,
      fileList: [],
      isUploadArr: [],
      imgs: ['jpg', 'png', 'gif', 'jpeg', 'tiff', 'psd', 'raw', 'eps', 'svg', 'bmp', 'pdf', 'PDF']
    }
  },
  computed: {
    headers() {
      return { 'X-TOKEN': Storage.get('wfUserInfo').token }
    },
    currentValue: {
      get: function () {
        return this.value || [];
      },
      set: function (newValue) {
        this.$emit('input', newValue || [])
      }
    },
    maxHeight() {
      return [...this.currentValue, ...this.isUploadArr].length * 50 + 'px'
    },
  },
  watch: {
    isUploadArr: {
      handler() {
        if (this.isUploadArr && this.isUploadArr.length > 0) {
          this.$emit('uploading', true)
        } else {
          this.$emit('uploading', false)
        }
      },
      deep: true
    }
  },
  mounted() {
    this.isMax = this.currentValue.length > 3
    bus.$on('selectUpload', (id) => {
      if (id === this.item.id) {
        this.emitUpload()
      }
    })
  },
  destroyed() {
    bus.$off('selectUpload')
  },
  methods: {
    handleProgerss(event, file, fileList) {
      console.log(event, file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleDownload(file) {
      console.log(file);
    },
    handleRemove(file) {
      console.log('remove', mfile);
    },
    beforeAvatarUpload(file) {
      let fileType = this.config.file_ext
      let arr = file.name.split('.')
      const isType = fileType.indexOf(arr[arr.length - 1].toLowerCase()) > -1
      const isLt2M = file.size < this.config.file_size;
      if (!isType) {
        this.$message.error(`[${file.name}]上传附件格式不支持!`);
      } else if ((file.size / Math.pow(1024, 2)).toFixed(2) > 50) {
        this.$message.error(`文件上传最高限制为50MB，请上传50MB以下的文件！`);
      } else if (!isLt2M) {
        this.$message.error(`该文件大小超过上传限制，请上传【${this.getfilesize(this.config.file_size)}】以下的文件!`);
      }
      return Boolean(isType) && Boolean(isLt2M)
    },
    getfilesize(size) {
      if (!size) return "";
      var num = 1024.00; //byte
      if (size < num)
        return size + "B";
      if (size < Math.pow(num, 2))
        return (size / num).toFixed(2) + "KB"; //kb
      if (size < Math.pow(num, 3))
        return (size / Math.pow(num, 2)).toFixed(2) + "MB"; //M
      if (size < Math.pow(num, 4))
        return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
      return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
    },
    onProgress(e, file, fileList) {
      console.log('上传中', file, fileList)
      this.isUploadArr = fileList
    },
    onUploadProgress(file) {
      let idx = this.isUploadArr.findIndex(res => res.name == file.name)
      let fl = this.beforeAvatarUpload(file)
      if (!fl) {
        file.source.cancel('取消上传')
        return
      } else if (idx > -1) {
        this.isUploadArr.splice(idx, 1, file)
      } else {
        this.isUploadArr.push(file)
      }
      if (file.percentage === 100) {
        file.visible = false
        this.$emit('change', { file })
        this.isUploadArr.splice(idx, 1)
      }
    },
    getIconType(file) {
      let type = file.uid ? file.name.substr(file.name.lastIndexOf(".") + 1) : file.attachment_type || file.type
      return this.getFileTypeUrl(type)
      // let item = this.fileIcon.find(res => res.list.indexOf(type) > -1)
      // return item ? item.icon : 'image/icon/icon_doc_annex.png'
    },
    success(response, file, fileList) {
      console.log('上传完成', response, file)
      this.$emit('change', { response, file, fileList })
      this.isUploadArr = []
      // api.uploadActionItemAttachments({ id: this.id, attachments: [file.response.data.id] }).then(res => {

      // }).catch(err => {
      //   console.log(err)
      // })
    },
    removeFile(obj) {
      console.log('删除附件', obj)
      obj.visible = false
      let idx
      this.currentValue.find((res, index) => {
        if (res.attachment_sign == obj.attachment_sign) {
          idx = index
          return
        }
      })
      this.$emit('remove', idx)
      this.isMax = this.currentValue.length > 3
    },
    onError(err) {
      this.$message.error(err.message ? JSON.parse(err.message).message : '上传失败或不支持该文件后缀')
    },
    async downLoadData(file) {
      if (file.loading) return
      this.getOssUrl(file.oss_attachment_name, data => {
        this.fileDown(data.sign_url, file.attachment_name, count => {
          this.$set(file, 'onDownLoading', count)
        })
      })
    },
    openViewReview(file) {
      if (file.loading) return
      this.getOssUrl(file.oss_attachment_name, data => {
        this.opendImgUrl(file.attachment_type, data.sign_url)
      })
    },
    exportData(data, fileName = '导出表.xls') {
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(data)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    },
    selfupload() {
      console.log(this.$refs.upload)
    },
    emitUpload() {
      this.$refs['hashInput'].focus()
      this.$refs['upload'].$el.getElementsByClassName('el-upload__input')[0].click()
    },
    getHeadText(data) {
      let idx = data.lastIndexOf(".") - 4
      return idx < 1 ? data.lastIndexOf(".") : idx
    },
    cancelUpload(file) { // 取消上传请求
      file.source.cancel('取消上传')
      let index = this.isUploadArr.findIndex(res => res.name == file.name)
      this.isUploadArr.splice(index, 1)
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin";
.metting-upload-action {
  width: 100%;
  position: relative;
  .add-box-input {
    position: absolute;
    z-index: -99;
    opacity: 0;
  }
  &:hover .more-box {
    display: block;
    line-height: 1;
  }
  .more-box {
    display: none;
    line-height: 32px;
    cursor: pointer;
  }
  .upload-box {
    margin-left: 8px;
  }
  .upload-box,
  .more-box {
    text-align: left;
    font-size: 14px;
    color: $color-active;
    i {
      font-size: 14px;
      margin-right: 2px;
      color: $color-active;
    }
  }
  .upload-list---item {
    height: 40px;
    border-radius: 4px;
    position: relative;
    cursor: pointer;
    background-color: #f7f8f9;
    // padding-right: 30px;
    &:hover {
      background: #f7f8f9;
    }
    &:active {
      background: #eaebec;
    }
  }
  .upload-list---text {
    display: flex;
    align-items: center;
    height: 100%;
    padding-left: 16px;
    box-sizing: border-box;
    .upload-list---text-in {
      display: flex;
      flex-direction: column;
      width: 0;
      flex: 1;
      height: 32px;
      justify-content: center;
    }
    >img {
      width: 24px;
      height:24px;
      margin-right: 8px;
    }
    .upload-list---text-img {
      width: 32px;
      height: 32px;
      margin-right: 16px;
    }
    p {
      font-size: 14px;
      display: flex;
      max-width: calc(100% - 150px);
      span:last-child {
        flex-shrink: 0;
      }
      span:first-child {
        @include ellipsis();
      }
    }
  }

  .el-progress-custom {
    margin: 0 auto;
    width: 100%;
    position: absolute;
    bottom: 20px;
    span {
      font-size: 12px;
    }
    .el-progress-bar__outer {
      height: 4px !important;
    }
  }
  .upoloadBox {
    margin-top: -4px;
    position: initial;
  }
  .file-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1.3;
  }
  .my-upload {
    .el-upload-dragger {
      height: auto;
      width: auto;
      border: 0 none;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .upload-demo {
      margin-top: 16px;
    }
    .el-upload-list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    .el-upload-list__item-preview {
      display: flex;
      align-items: center;
    }
  }
  .my-upload-list {
    // width: 100%;
    display: flex;
    flex-direction: column;
    margin-left: 8px;
    // justify-content: center;
    overflow: hidden;
    .upload-list-box {
      position: relative;
      margin-bottom: 8px;
      &:hover .my-upload-del {
        .tool-icon {
          display: flex;
        }
        .my-upload-del-szie {
          display: none;
        }
      }
      &:hover .not-none {
        span {
          display: block;
        }
      }
      .my-upload-del {
        font-size: 12px;
        position: absolute;
        top: 50%;
        right: 16px;
        z-index: 1;
        cursor: pointer;
        transform: translate(0, -50%);
        line-height: 1;
        display: flex;
        align-items: center;
        color: #575c63;
        i {
          font-size: 14px;
        }
        .iconicon_delete_annex {
          margin-left: 16px;
          &:hover {
            color: $color-active;
          }
        }
        .tool-icon {
          display: none;
          align-items: center;
        }
        .my-upload-del-szie {
          display: block;
        }
      }
    }
  }
  .el-progress__text {
    font-size: 12px !important;
    display: none;
  }
  .el-progress-bar {
    margin-right: 0;
    padding-right: 0;
  }
  .more-file {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 0.3em;
  }
}
.onlyValue-rest {
  margin: 16px 0;
  width: 436px;
  .upload-list-box {
    margin:0 !important;
    height: 80px;
    flex-shrink: 0;
  }
  .upload-list---text{
    height: 80px;
    padding: 0 16px;
  }
  .upload-list-box:not(:last-child) {
    .upload-list---text {
      border-bottom: 1px solid rgba(32, 32, 32, 0.08);
    }
  }

  .my-upload-list {
    max-height: 100000px !important;
    margin: 0 16px;
  }
  .upload-list---item{
    background-color: #fff;
    height: 80px;
  }
  .file-bottom {
    justify-content: center;
    padding-top: 16px;
    border-top: 1px solid rgba(32, 32, 32, 0.08);
    margin-top: 8px;
  }
}
</style>
